// dysonSphereGenerator.js
var DysonSphereGenerator = pc.createScript('dysonSphereGenerator');

DysonSphereGenerator.attributes.add('ammount', {type:'number', title:'elementAmmount'});
DysonSphereGenerator.attributes.add('baseMesh', {type:'entity', array:true, title:'baseShapes'});
DysonSphereGenerator.attributes.add('distMesh', {type:'entity', array:true, title:'distributionObjs'});
DysonSphereGenerator.attributes.add('theSun', {type:'entity', title:'sun'});
DysonSphereGenerator.attributes.add('civParticles', {type:'entity', title:'particles'});
DysonSphereGenerator.attributes.add('distPool', {type:'entity', title:'distributionPool'});
DysonSphereGenerator.attributes.add('distPos', {type:'number'});
DysonSphereGenerator.attributes.add('stations', {type:'entity', array:true, title:'stations'});

// initialize code called once per entity
DysonSphereGenerator.prototype.initialize = function() {
    
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.theSeed = 0.0;
    this.randomize = 0.0;
    
    
    this.app.on('systemGenerator:kill', this.hidePs, this);
   // this.app.once('sunGenerator:dysonTrigger', this.start, this);
    this.shapeRandom = 0;
    this.shape = null;
    this.distRandom = 0;
    this.dist = null;
    this.distEnts = [];
    this.lightMat = null;
    this.sunScript = this.theSun.script.sunGenerator;
    
    this.ps = this.civParticles.particlesystem;
    
};

DysonSphereGenerator.prototype.hidePs = function(){
    this.ps.stop();
    this.ps.enabled = false;
};

DysonSphereGenerator.prototype.start = function(bc, bs) {
    
    this.initialize();
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.theSeed);
    
    // hide stations
    for(var l = 0; l < this.stations.length; l++){
        this.stations[l].enabled = false;
    }
    this.distPool.setPosition(this.distPos,0,0);
    this.shapeRandom = Math.floor(this.randomize() * this.baseMesh.length);
    this.shape = this.baseMesh[this.shapeRandom];
    this.distRandom = Math.floor(this.randomize() * this.distMesh.length);
    this.dist = this.distMesh[this.distRandom];
    this.lightMat = this.dist.model.model.meshInstances[1].material;
    this.highLightMat = this.dist.model.model.meshInstances[2].material;
    this.setSphere(bc, bs);    
};

DysonSphereGenerator.prototype.setSphere = function(clr, scl) {

    var rndsz = scl;
    


    //set stations
   
    
    for(var s = 1; s < 6; s++){
       if(this.randomize() > 0.5){
           var rnd = this.randomize() * 360;
           this.stations[s].enabled = true;
           this.stations[s].setLocalEulerAngles(rnd,rnd,rnd);
         //  console.log('nm: ' + this.stations[s].name + ' en: ' + this.stations[s].enabled);
       } else {
           this.stations[s].enabled = false;
       }
    }
    
    this.stations[0].enabled = true;
    this.stations[0].setLocalEulerAngles(this.randomize() * 360,this.randomize() * 360,this.randomize() * 360);  
    
    
    
    //console.log('scl: ' + scl + 'baseObj: ' + this.baseMesh[this.shapeRandom].name);
    var val = 1;
    
    if(scl > 0 && scl <= 1){
        rndsz = val;
    } else if(scl > 1 && scl <= 2){
        rndsz = val;
    } else if(scl > 2 && scl <= 3){
        rndsz = 2;
    } else if(scl > 3 && scl <= 4){
        rndsz = 1.3;
    } else if(scl > 4 && scl <= 5){
        rndsz = 1.75;
    } else if(scl > 5 && scl <= 6){
        rndsz =1.25;
    } else if(scl > 6 && scl <= 7){
        rndsz = 1.25;
    } else if(scl > 7 && scl <= 8){
        rndsz = 1.15;
    } else if(scl > 8 && scl <= 9){
        rndsz = 1.15;
    } else if(scl > 9 && scl <= 10){
        rndsz = 1.5;
    } else if(scl > 10){
        rndsz = 1.7;
    }
    
    
   // console.log('shape: ' + this.shape.name + ' rndsz: ' + rndsz + ' scl: ' + scl);
    this.ps.emitterRadius = rndsz * 500;
    this.ps.emitterRadiusInner = rndsz * 450;
    this.ps.reset();
    this.ps.play();
    
    //iterate through mesh vertecies
    //
    var buffer = this.shape.model.model.meshInstances[0].mesh.vertexBuffer;
    var iterator = new pc.VertexIterator(buffer);
    var objectArray = this.distPool.children;
    //console.log('distpooli: ' + this.distPool.children);
    
   //console.log('DYSON GENERATOR r: ' + clr.r + ' g: ' + clr.g + ' b: ' + clr.b);
    this.lightMat.emissive = clr;
    this.highLightMat.emissive = clr;
    this.lightMat.update();
    this.highLightMat.update();
    
    for(i = 0; i < buffer.getNumVertices(); i++) {

        // Current vertex's position
        var posSem = iterator.element[pc.SEMANTIC_POSITION];
    
        // Get position
        var posX = posSem.array[posSem.index] * rndsz;
        var posY = posSem.array[posSem.index + 1] * rndsz;
        var posZ = posSem.array[posSem.index + 2] * rndsz;

        //var cln = this.dist.clone();
        var cln = objectArray[i];
        //console.info(this.distPool);

        cln.children[this.distRandom].setPosition(posX + this.distPos, posY, posZ);
        //console.info(this.theSun.getPosition());
        cln.children[this.distRandom].lookAt(this.distPos,0,0);
        cln.children[this.distRandom].enabled = true;
        //this.distPool.addChild(cln);
        this.distEnts.push(cln.children[this.distRandom]);
               
        // Move to the next vertex
        iterator.next();
    }
    
    iterator.end(); 
    this.app.fire('DysonGenerator:StartAnim',this.distEnts);
    
    
    this.app.batcher.generate();
    //console.log('distents: ' + this.distEnts.length);
    
};


// update code called every frame
DysonSphereGenerator.prototype.update = function(dt) {
};

// swap method called for script hot-reloading
// inherit your script state here
// DysonSphereGenerator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

